import { createContext, Dispatch, KeyboardEvent, SetStateAction } from "react";

type TabContextProps = {
  current: number; // id of tabpanel
  setCurrent?: Dispatch<SetStateAction<number | undefined>>;
  focus: number; // id of tabpanel
  setFocus?: Dispatch<SetStateAction<number>>;
  items?: NodeListOf<HTMLElement>;
  uid?: string;
  onKeyDownHandler?: (e: KeyboardEvent<HTMLButtonElement>) => void;
  gotoNext?: (refocus?: boolean) => void;
  goToPrev?: (refocus?: boolean) => void;
  dir?: string;
};

const initialValue = {
  current: 0,
  focus: 0,
};

export const TabContext = createContext<TabContextProps>(initialValue);
